import { render, staticRenderFns } from "./CurrentIssue.vue?vue&type=template&id=df13c864&scoped=true"
import script from "./CurrentIssue.vue?vue&type=script&lang=js"
export * from "./CurrentIssue.vue?vue&type=script&lang=js"
import style0 from "./CurrentIssue.vue?vue&type=style&index=0&id=df13c864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df13c864",
  null
  
)

export default component.exports